import { userApi } from '~/api'
import { useQuery } from '@tanstack/react-query'

export const useCourseQuery = (id) =>
  useQuery({
    queryKey: ['courses', id],
    queryFn: async () => {
      const { data } = await userApi.getCourseDetail(id)
      return data.data
    }
  })

export const useCaseQuery = (id) =>
  useQuery({
    queryKey: ['cases', id],
    queryFn: async () => {
      const { data } = await userApi.getCases(id)
      return data.data
    }
  })
